import React from 'react'

import { FaceProps } from '../../'
import { Image } from '../partials/Image'

import { useImageFaceBase } from './base'

const ImageFace = (props: FaceProps) => {
  const { token, viewMode } = props
  const icon = viewMode === 'icon'
  const resizeMode = icon ? 'cover' : 'contain'
  const { img, style } = useImageFaceBase(props)

  return (
    <>
      {img ? (
        <Image
          accessibilityIgnoresInvertColors
          alt={token?.metadata.name || 'token'}
          source={{
            // cache: 'force-cache',
            headers: {
              Accept: '*/*'
            },
            uri: img
          }}
          resizeMode={resizeMode}
          style={style.img}
        />
      ) : null}
    </>
  )
}

Object.defineProperty(ImageFace, 'name', {
  writable: true,
  value: 'ImageFace'
})

export default ImageFace
